import React, { Component, PureComponent } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

@inject('lineStore', 'dictStore')
@observer
export default class List extends Component {

  render () {

    const {order, schedule, dict} = this.props.lineStore.schedule;
    const {getLang} = this.props.dictStore;

    if (!order.length) {
      return (<div className="result-no-events">{ getLang('NO_EVENTS') }</div>);
    }

    let sidAk;
    let lidAk;
    const list = [];

    order.map(id => {
      const sch = schedule[id];
      if (sidAk != sch.sid) {
        sidAk = sch.sid;
        list.push(<Sport id={ sch.sid } key={ id + dict.sport[sch.sid] } name={ dict.sport[sch.sid] }/>);
      }
      if (lidAk != sch.lid) {
        lidAk = sch.lid;
        list.push(<League id={ sch.lid } name={ dict.league[sch.lid] }/>);
      }

      list.push(<Game lineId={ sch.line_id } id={ id } sid={ sch.sid } lid={ sch.lid }/>);

    });

    return (
      <div>
        { list }
      </div>
    );
  }
}

// @inject('lineStore')
// @observer
// class Shedule extends Component{
//
//   render() {
//
//     const {c1_id} = this.props.lineStore.schedule.schedule[this.props.id];
//
//     return(
//       <div>{c1_id}</div>
//     )
//   }
// }

class Sport extends Component {

  render () {

    const {id, name} = this.props;

    return (
      <div className="l-s-c clearfix">
        <div className={ `l-s-r l-s-r-${ id }` }></div>
        <div className="l-s-l-c">
          <div className={ `l-s-c-i  f-s-ico-${ id }` }></div>
          <div className="l-s-l">{ name }</div>
        </div>
      </div>
    );
  }
}

class League extends PureComponent {

  render () {

    const {name} = this.props;

    return (
      <table className="l-t">
        <tbody>
        <tr>
          <th className="l-td" colSpan="3">
            <div className="l-d">{ name }</div>
          </th>
        </tr>
        </tbody>
      </table>
    );
  }
}

@withRouter
@inject('lineStore', 'dictStore')
@observer
class Game extends Component {

  route = () => {
    if (this.props.lineId) this.props.history.push(`/line/${ this.props.sid }/${ this.props.lid }/${ this.props.lineId }`);
  };

  render () {

    const {c1_id, c2_id, date, tv, is_cupis_video} = this.props.lineStore.schedule.schedule[this.props.id];
    const {dict} = this.props.lineStore.schedule;
    const {getLang} = this.props.dictStore;
    const name = `${ dict.cmd[c1_id] } ${ c2_id ? ` - ${ dict.cmd[c2_id] }` : '' }`;

    return (
      <table className="l-t">
        <tbody>
        <tr className={ `g-tr` }>
          <td className="g-d-date">
            <div className="g-date">{ date }</div>
          </td>
          <td className="results-index-game-cmd g-d-players">
            <div className="clearfix">
              <b className="g-d g-b_link" onClick={ this.route }>{ name }</b>
              {is_cupis_video ? (
                <span
                  className="item-ico-video f-s-ico-icon_live_tv"
                  title={getLang('VIDEO_WILL_BE_AVAILABLE_ON_OUR_SITE')}
                />
              ) : (
                ''
              )}
              { tv ? <div className="schedule-item-tv">{ tv }</div> : '' }
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/schedule/list.jsx